import { Component } from '@angular/core';

import { LeaderboardType } from '@fgb/core';

@Component({
  selector: 'fgb-fantasy-leaderboard-page',
  templateUrl: './fantasy-leaderboard.component.html',
  styleUrls: ['./fantasy-leaderboard.component.scss'],
})
export class FantasyLeaderboardPageComponent {
  LeaderboardType: LeaderboardType = LeaderboardType.FantasyPoints;
}
